module.exports = __webpack_public_path__ + "static/media/Questions-19-28.7c3f1adb.png";